<div fxLayout="row" fxLayoutAlign="start center">
  <mat-icon *ngIf="icon" [ngClass]="iconStyle ? 'material-icons-' + iconStyle : ''">{{icon}}</mat-icon>
  <div fxLayout="column">
    <span class="mat-body-1">{{header}}</span>
    <span class="mat-caption">{{subheader}} </span>
  </div>
</div>
